import React, {useState,useEffect,useRef} from 'react'
import { allProds } from 'network/ApiAxiosMerchShop';
import ProdCard from './ProdCard';
import { Row, Col, Input, Button , Container, Label} from "reactstrap";
import ShopCart from './ShopCart';
import BarCodeScanner from './BarCodeScanner';
import Header from 'components/Headers/Header';
import BarCodeScannerCamera from './BarCodeScannerCamera';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';

function MainShop() {
  const [prods, setProds] = useState('');
  const [filteredProds, setFilteredProds] = useState('');
  const [houseToggle, setHouseToggle] = useState(true);
  const [reload, setReload] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const [sizeFilter, setSizeFilter] = useState(null);
  const [houseFilter, sethouseFilter] = useState(null);
  const [stockFilter, setStockFilter] = useState(false);

  const [scrollBottom, setscrollBottom] = useState(false);
  const messageRef = useRef();

  useEffect(() => {
    getProds()
  }, [trigger]);

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        })
    }
  },
  [scrollBottom])

  /* useEffect(() => {
    updateCart()
  }, []); */

  const getProds = async()=>{
    const resp = await allProds()
    if(resp.data){
      setProds(resp.data)
      setFilteredProds(resp.data)
      if(houseFilter || sizeFilter || stockFilter)applyFilters()
    }
  }

  const resetFilters = ()=>{
    setFilteredProds(prods)
  }

  const updateCart = ()=>{
    setTrigger(!trigger)
    
  }

  const applyFilters = ()=>{
    console.log(houseFilter ? 'true' : false)
    console.log(sizeFilter? 'true' : false)
    console.log(stockFilter? 'true' : false)
    let tempArray = prods
    if(houseFilter) tempArray = tempArray.filter((prodItem)=> prodItem.house == houseFilter)
    if(sizeFilter) tempArray = tempArray.filter((prodItem)=> prodItem.size == sizeFilter)
    if(stockFilter) tempArray = tempArray.filter((prodItem)=> prodItem.stock > 0 )
    setFilteredProds(tempArray)
  }

  return (
    <>
      <Header/>
      <Container className='mt--4'>
          <Row>
            <Col className='mb-2 d-flex justify-content-center'>
              <label className='mt--1 mr-2'>Size:</label>
              <Input type="select" onChange={(e)=>setSizeFilter(e.target.value)} >
                  <option key="9" value='NA' label="N.A" >N.A</option>                          
                  <option key="1" value='XS' label="XS" >XS</option>
                  <option key="2" value='S' label="S" >S</option>
                  <option key="3" value='M' label="M" >M</option>
                  <option key="4" value='L' label="L" >L</option>
                  <option key="5" value='XL' label="XL" >XL</option>
                  <option key="6" value='XXL' label="2XL" >2XL</option>
                  <option key="7" value='XXXL' label="3XL" >3XL</option>
                  <option key="8" value='XXXXL' label="4XL" >4XL</option>
              </Input>
            </Col>
            <Col className='mb-2 d-flex justify-content-center'>
              <label className='mt--1 mr-2'>House:</label>
              <Input name="select" type="select" onChange={(e) => sethouseFilter(e.target.value)}>
                    <option value=''> </option>
                    <option value='Heaven'>Heaven </option>
                    <option value='Albufeira 66'>Albufeira 66 </option>
                    <option value='Albufissa'>Albufissa </option>
                    <option value='Tropicana'>Tropicana </option>
                    <option value='Heaven Wharehouse'>Heaven's Wharehouse </option>
                    <option value='Beach Club'>Beach Club </option>
                    <option value='Other'>Other </option>
                </Input>
            </Col>
            <Col className='mb-2 d-flex justify-content-center'>
              <label className='mt-1'>In Stock:
              <input type="checkbox" id="exampleCheck" className='ml-3' name="check" style={{scale:'3'}} checked={stockFilter} onChange={(e)=>{setStockFilter(!stockFilter)}}/>
              </label>
            </Col>
            <Col className='mb-2 d-flex justify-content-center'>
              <Button className='btn-info' onClick={()=>applyFilters()}>Apply Filters</Button>
              <Button className='btn-danger' onClick={()=>resetFilters()}>Reset Filters</Button>
            </Col>
          </Row>

          {/*<BarCodeScanner updateCartQT={updateCart}/>*/}

          <BarCodeScannerCamera updateCartQT={updateCart}/>
          

          <Row className='mt-2'>
            <Col md={9}>
              <Row>
                {filteredProds && filteredProds.map((prodItem)=>{
                  return <Col md='3' key={prodItem._id + 'col'} className='mb-2 d-flex justify-content-center'>
                      <ProdCard key={prodItem._id} update={setTrigger} updateState={trigger} updateCartQT={updateCart} name={prodItem.desc + ' ' + prodItem.house + ' ' + prodItem.color} price={prodItem.price} prod={prodItem} size={prodItem.size} />
                    </Col>
                })}
              </Row>
            </Col>
            <Col md={3} className='border-info border'>
              <ShopCart updateCartQT={trigger} refreshCart={updateCart} ref={messageRef}/>
            </Col>
          </Row>
          <Button style={{position:'fixed',bottom:'80px',right:'32px'}} onClick={()=>window.scrollTo({top: 0,behavior: 'smooth'})}><ArrowUpward/></Button>
          <Button style={{position:'fixed',bottom:'30px',right:'40px'}} onClick={()=>window.scrollTo({top: document.body.scrollHeight,behavior: 'smooth'})}><ArrowDownward/></Button>
      </Container>
    </>
  )
}

export default MainShop